import { render, staticRenderFns } from "./CrmReportList.vue?vue&type=template&id=3b664eca"
import script from "./CrmReportList.vue?vue&type=script&lang=js"
export * from "./CrmReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports